import React, { forwardRef } from "react"

import { getLabelClasses, getMarketingLabelClasses } from "./style"
import type { LabelProps } from "./types"
import { useIsAppTheme } from "../../../contexts/Theme/Theme"

export const Label = forwardRef<HTMLElement, LabelProps>((props, ref) => {
  const {
    testId,
    children,
    size = 1,
    className,
    as: As = "span",
    numberOfLines,
    role,
    selectable = true,
    leading,
    ...rest
  } = props
  const isAppTheme = useIsAppTheme()
  const getClasses = isAppTheme ? getLabelClasses : getMarketingLabelClasses

  return (
    <As
      data-testid={testId ?? `label-${size}`}
      role={role}
      className={getClasses({ size, selectable, numberOfLines, className, leading })}
      ref={ref}
      {...rest}>
      {children}
    </As>
  )
})

Label.displayName = "Label"
